import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { RecurrenceType } from "../../../create-poll/create-poll.type";
import { PollListItem } from "../../user-polls.type";
import { UserPollsService } from "../../user-polls.service";
import { Subject, debounceTime, distinctUntilChanged, takeUntil, tap } from "rxjs";
import { NgClass } from "@angular/common";

@Component({
    selector: 'make-poll-reccurrent-form',
    templateUrl: './make-poll-reccurrent-form.component.html',
    styleUrls: ['./make-poll-reccurrent-form.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        ReactiveFormsModule,
        TranslateModule,
]
})
export class MakePollRecurrentFormComponent implements OnInit {

    @Input() frequency: RecurrenceType;
    @Input() poll: PollListItem;
    @Input() context: 'simple' | 'complex' = 'simple';

    @Output() onDurationValueChanged = new EventEmitter();
       
    protected value: string | number;
    protected errorMessage: string;
    protected displayDurationCtrl = new FormControl<number>(5);

    private _destroy$ = new Subject<void>();

    constructor(
        protected translate: TranslateService,
        protected userPollsService: UserPollsService
    ) { }

    ngOnInit() {
        this.value = this.userPollsService.getFrequencyStartDay(this.poll.occurrences[0].startDate, this.frequency);

        switch(this.frequency){
            case 'weekly':
                this.displayDurationCtrl.setValidators([Validators.required, Validators.min(1), Validators.max(7)]);
                this.errorMessage = this.translate.instant('polls_settings.make_recurrent.duration_error.weekly')
                break;
            case 'monthly':
                this.displayDurationCtrl.setValidators([Validators.required, Validators.min(1), Validators.max(15)]);
                this.errorMessage = this.translate.instant('polls_settings.make_recurrent.duration_error.monthly')
                break;
        }

        this.displayDurationCtrl.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap(async (duration) => {
                this.poll.duration = duration;
                this.onDurationValueChanged.emit(this.poll);
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }
}

